<app-customer-service-content></app-customer-service-content>

<cx-storefront></cx-storefront>
<ng-template cxOutletRef="SrpToggle" let-model>
  <app-srp-toggle></app-srp-toggle>
</ng-template>
<ng-template cxOutletRef="ProductImagesComponent" cxOutletPos="after">
  <app-shimano-image-zoom></app-shimano-image-zoom>
</ng-template>
<ng-template cxOutletRef="header" cxOutletPos="after">
  <app-tawk-live-chat></app-tawk-live-chat>
</ng-template>
